export default function PHP_registerXPathNamespace() {
  return (
    <div>
      <h1>PHP_registerXPathNamespace</h1>
    </div>
  );
}
